import Sidebar from "../../Components/Sidebar/Sidebar";
import Header from "../../Components/Header/Header";
import classes from "./Laboratory.module.css";
import LabResult from "./LabResult";
import { useState } from "react";

import {
    FaFlask,
    FaVial,
    FaCheckCircle,
    FaExclamationTriangle,
    FaTimesCircle,
    FaBan,
    FaArrowUp,
    FaArrowDown,
    FaPlus,
    FaSearch,
    FaFilter,
    FaEye,
    FaPrint,
    FaChevronLeft,
    FaChevronRight,
    FaTimes,
} from "react-icons/fa";
const stats = [
    {
        title: "Total Tests Today",
        value: "328",
        change: "12.5%",
        direction: "up",
        color: "#7C3AED",
        bg: "#F5F3FF",
        icon: <FaFlask />,
    },
    {
        title: "Pending Tests",
        value: "136",
        change: "5.3%",
        direction: "down",
        color: "#F59E0B",
        bg: "#FFF7ED",
        icon: <FaVial />,
    },
    {
        title: "Completed Today",
        value: "182",
        change: "18.6%",
        direction: "up",
        color: "#22C55E",
        bg: "#ECDF5",
        icon: <FaCheckCircle />,
    },
    {
        title: "Critical Results",
        value: "12",
        change: "2",
        direction: "up",
        color: "#EF4444",
        bg: "#FEF2F2",
        icon: <FaExclamationTriangle />,
    },
    {
        title: "Rejected Samples",
        value: "05",
        change: "2",
        direction: "up",
        color: "#3B82F6",
        bg: "#EFF6FF",
        icon: <FaTimesCircle />,
    },
    {
        title: "Cancelled Tests",
        value: "03",
        change: "1",
        direction: "up",
        color: "#06B6D4",
        bg: "#ECFEFF",
        icon: <FaBan />,
    },
];

const tabs = [
    "All Tests",
    "Pending",
    "In Progress",
    "Completed",
    "Critical",
    "Rejected",
    "Cancelled",
];
const tests = [
    {
        labNo: "LAB240521-001",
        patient: "John Doe",
        patientId: "OPD - 12345",
        test: "Complete Blood Count (CBC)",
        department: "Hematology",
        status: "Completed",
        priority: "Normal",
        collected: "21 May 2024\n08:30 PM",
        expected: "21 May 2024\n02:00 PM",
    },
    {
        labNo: "LAB240521-002",
        patient: "Mary Jane",
        patientId: "OPD - 12346",
        test: "Blood Sugar (Fasting)",
        department: "Biochemistry",
        status: "In Progress",
        priority: "Normal",
        collected: "21 May 2024\n08:45 AM",
        expected: "21 May 2024\n12:00 PM",
    },
    {
        labNo: "LAB240521-003",
        patient: "Robert Brown",
        patientId: "IPD - 54321",
        test: "Liver Function Test (LFT)",
        department: "Biochemistry",
        status: "Pending",
        priority: "High",
        collected: "21 May 2024\n09:10 AM",
        expected: "22 May 2024\n11:00 AM",
    },
    {
        labNo: "LAB240521-004",
        patient: "Linda White",
        patientId: "OPD - 12347",
        test: "Thyroid Profile (T3,T4,TSH)",
        department: "Immunology",
        status: "Completed",
        priority: "Normal",
        collected: "21 May 2024\n09:20 AM",
        expected: "21 May 2024\n03:00 PM",
    },


    {
        labNo: "LAB240521-005",
        patient: "Michael Lee",
        patientId: "IPD - 54322",
        test: "Urine Routine & Microscopy",
        department: "Microbiology",
        status: "Pending",
        priority: "Normal",
        collected: "21 May 2024\n09:35 AM",
        expected: "22 May 2024\n10:00 AM",
    },
    {
        labNo: "LAB240521-006",
        patient: "Patricia Green",
        patientId: "OPD - 12348",
        test: "Lipid Profile",
        department: "Biochemistry",
        status: "Completed",
        priority: "Normal",
        collected: "21 May 2024\n10:00 AM",
        expected: "21 May 2024\n01:30 PM",
    },
    {
        labNo: "LAB240521-007",
        patient: "David Wilson",
        patientId: "OPD - 12349",
        test: "Dengue NS1 Antigen",
        department: "Serology",
        status: "In Progress",
        priority: "High",
        collected: "21 May 2024\n10:20 AM",
        expected: "21 May 2024\n06:00 PM",
    },
    {
        labNo: "LAB240521-008",
        patient: "Jennifer Taylor",
        patientId: "IPD - 54323",
        test: "Electrolyte Panel",
        department: "Biochemistry",
        status: "Pending",
        priority: "Normal",
        collected: "21 May 2024\n10:40 AM",
        expected: "22 May 2024\n12:00 PM",
    },
];
function Laboratory() {
    const [activeTab, setActiveTab] = useState("All Tests");
    const [search, setSearch] = useState("");
    const [showFilter, setShowFilter] = useState(false);
    const [selectedTest, setSelectedTest] = useState(null);
    const [showNewTest, setShowNewTest] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5; const filteredTests = tests.filter((item) => {
        const matchesSearch =
            item.patient.toLowerCase().includes(search.toLowerCase()) ||
            item.labNo.toLowerCase().includes(search.toLowerCase()) ||
            item.test.toLowerCase().includes(search.toLowerCase());
        const matchesTab = activeTab === "All Tests" ? true : item.status === activeTab;
        return matchesSearch && matchesTab;
    });
    const totalPages = Math.ceil(
        filteredTests.length / rowsPerPage
    );
    const paginatedTests =
        filteredTests.slice(
            (currentPage - 1) * rowsPerPage,
            currentPage * rowsPerPage
        );

    const handleView = (test) => {

        setSelectedTest(test);

    };

    const handlePrint = () => {

        window.print();

    };

    const generateReport = () => {

        alert("Laboratory report generated");

    };

    const createLabTest = () => {

        setShowNewTest(true);

    };
    return (

        <div className={classes.page}>
            <Sidebar />
            <div className={classes.main}>
                <Header />
                <div className={classes.content}>
                    <div className={classes.topSection}><div>
                        <h2 className={classes.pageTitle}>Laboratory</h2>
                        <p className={classes.breadcrumb}>
                            Dashboard
                            <span> &gt; </span>
                            Laboratory
                        </p>
                    </div>
                        <div className={classes.topButtons}>
                            <button
                                className={classes.newBtn}
                                onClick={createLabTest}
                            >

                                <FaPlus />

                                <span>
                                    New Lab Test
                                </span>


                            </button>



                            <button
                                className={classes.reportBtn}
                                onClick={generateReport}
                            >

                                <FaPrint />

                                <span>
                                    Reports
                                </span>


                            </button>


                        </div>


                    </div>





                    {/* STAT CARDS */}

                    <div className={classes.statsGrid}>


                        {
                            stats.map((item, index) => (


                                <div
                                    key={index}
                                    className={classes.statCard}
                                >


                                    <div
                                        className={classes.iconBox}
                                        style={{
                                            background: item.bg,
                                            color: item.color
                                        }}
                                    >

                                        {item.icon}

                                    </div>



                                    <div className={classes.statContent}>


                                        <p className={classes.statTitle}>
                                            {item.title}
                                        </p>



                                        <h2 className={classes.statValue}>
                                            {item.value}
                                        </h2>



                                        <div
                                            className={classes.statChange}
                                        >

                                            {
                                                item.direction === "up"
                                                    ?
                                                    <FaArrowUp />
                                                    :
                                                    <FaArrowDown />
                                            }


                                            <span>

                                                {item.change}

                                                from yesterday

                                            </span>


                                        </div>


                                    </div>


                                </div>


                            ))
                        }



                    </div>





                    <div className={classes.middleSection}>


                        <div className={classes.leftSection}>


                            <div className={classes.tableHeader}>


                                <div className={classes.tabs}>


                                    {
                                        tabs.map((tab) => (


                                            <button
                                                key={tab}
                                                onClick={() => {

                                                    setActiveTab(tab);
                                                    setCurrentPage(1);

                                                }}

                                                className={
                                                    activeTab === tab
                                                        ?
                                                        classes.activeTab
                                                        :
                                                        classes.tab
                                                }

                                            >

                                                {tab}

                                            </button>


                                        ))
                                    }



                                </div>




                                <div className={classes.tableActions} style={{ position: 'relative' }}>
                                    <div className={classes.searchBox}>
                                        <FaSearch />
                                        <input
                                            value={search}
                                            onChange={(e) => {
                                                setSearch(e.target.value);
                                                setCurrentPage(1);
                                            }}
                                            placeholder="Search by Patient, Lab No, Test..."
                                        />
                                    </div>

                                    <button
                                        className={classes.filterBtn}
                                        onClick={() => setShowFilter(!showFilter)}
                                    >
                                        <FaFilter />
                                        <span>Filter</span>
                                    </button>

                                    {showFilter && (
                                        <div className={classes.filterMenu}>
                                            <button onClick={() => { setActiveTab("All Tests"); setShowFilter(false); }}>
                                                All
                                            </button>
                                            <button onClick={() => { setActiveTab("Pending"); setShowFilter(false); }}>
                                                Pending
                                            </button>
                                            <button onClick={() => { setActiveTab("Completed"); setShowFilter(false); }}>
                                                Completed
                                            </button>
                                            <button onClick={() => { setActiveTab("In Progress"); setShowFilter(false); }}>
                                                In Progress
                                            </button>
                                        </div>
                                    )}
                                </div>



                            </div>





                            <div className={classes.tableCard}>


                                <table className={classes.table}>


                                    <thead>


                                        <tr>

                                            <th>Lab No.</th>

                                            <th>Patient Name</th>

                                            <th>Test</th>

                                            <th>Department</th>

                                            <th>Status</th>

                                            <th>Priority</th>

                                            <th>Sample Collected</th>

                                            <th>Expected Date</th>

                                            <th>Action</th>


                                        </tr>


                                    </thead>




                                    <tbody>


                                        {

                                            paginatedTests.map((test, index) => (


                                                <tr key={index}>


                                                    <td>
                                                        {test.labNo}
                                                    </td>



                                                    <td>

                                                        <strong>
                                                            {test.patient}
                                                        </strong>

                                                        <br />

                                                        <span>
                                                            {test.patientId}
                                                        </span>


                                                    </td>



                                                    <td>
                                                        {test.test}
                                                    </td>


                                                    <td>
                                                        {test.department}
                                                    </td>




                                                    <td>


                                                        <span

                                                            className={`

${classes.badge}

${test.status === "Completed"
                                                                    ?
                                                                    classes.completed
                                                                    :
                                                                    test.status === "Pending"
                                                                        ?
                                                                        classes.pending
                                                                        :
                                                                        classes.progress

                                                                }

`}

                                                        >

                                                            {test.status}

                                                        </span>



                                                    </td>





                                                    <td>


                                                        <span

                                                            className={`

${classes.badge}

${test.priority === "High"
                                                                    ?
                                                                    classes.high
                                                                    :
                                                                    classes.normal

                                                                }

`}

                                                        >

                                                            {test.priority}

                                                        </span>


                                                    </td>




                                                    <td
                                                        style={{
                                                            whiteSpace: "pre-line"
                                                        }}
                                                    >

                                                        {test.collected}

                                                    </td>




                                                    <td
                                                        style={{
                                                            whiteSpace: "pre-line"
                                                        }}
                                                    >

                                                        {test.expected}

                                                    </td>





                                                    <td>


                                                        <div className={classes.actionIcons}>


                                                            <button onClick={() => setSelectedTest(test)}>
                                                                <FaEye />
                                                            </button>



                                                            <button
                                                                onClick={handlePrint}
                                                            >

                                                                <FaPrint />

                                                            </button>


                                                        </div>


                                                    </td>



                                                </tr>


                                            ))


                                        }



                                    </tbody>


                                </table>





                                <div className={classes.pagination}>


                                    <span>

                                        Showing {

                                            paginatedTests.length

                                        }

                                        entries


                                    </span>




                                    <div className={classes.pageButtons}>


                                        <button

                                            disabled={currentPage === 1}

                                            onClick={() => setCurrentPage(currentPage - 1)}

                                        >

                                            <FaChevronLeft />

                                        </button>




                                        {

                                            Array.from(
                                                {
                                                    length: totalPages
                                                },
                                                (_, i) => (


                                                    <button

                                                        key={i}

                                                        className={
                                                            currentPage === i + 1
                                                                ?
                                                                classes.activePage
                                                                :
                                                                ""
                                                        }

                                                        onClick={() => setCurrentPage(i + 1)}

                                                    >

                                                        {i + 1}

                                                    </button>


                                                ))

                                        }




                                        <button

                                            disabled={currentPage === totalPages}

                                            onClick={() => setCurrentPage(currentPage + 1)}

                                        >

                                            <FaChevronRight />

                                        </button>



                                    </div>


                                </div>


                            </div>


                        </div>
                        {/* RIGHT SECTION */}

                        <div className={classes.rightSection}>


                            <div className={classes.sampleCard}>


                                <div className={classes.cardHeader}>

                                    <h3>
                                        Sample Collection
                                    </h3>


                                    <span>
                                        This Week
                                    </span>


                                </div>



                                <div className={classes.chartContainer}>


                                    <div className={classes.donutChart}>


                                        <div className={classes.chartCenter}>


                                            <h2>
                                                86%
                                            </h2>


                                            <p>
                                                Collected
                                            </p>


                                        </div>


                                    </div>


                                </div>





                                <div className={classes.chartLegend}>


                                    <div className={classes.legendItem}>


                                        <span
                                            className={classes.legendDot}
                                            style={{
                                                background: "#22C55E"
                                            }}
                                        ></span>


                                        <span>
                                            Collected
                                        </span>


                                        <strong>
                                            86%
                                        </strong>


                                    </div>




                                    <div className={classes.legendItem}>


                                        <span
                                            className={classes.legendDot}
                                            style={{
                                                background: "#F59E0B"
                                            }}
                                        ></span>


                                        <span>
                                            Pending
                                        </span>


                                        <strong>
                                            14%
                                        </strong>


                                    </div>


                                </div>


                            </div>






                            <div className={classes.alertCard}>


                                <div className={classes.cardHeader}>


                                    <h3>
                                        Lab Alerts
                                    </h3>


                                    <span>
                                        View All
                                    </span>


                                </div>




                                <div className={classes.alertItem}>


                                    <div className={classes.redDot}></div>


                                    <div>

                                        <strong>
                                            Critical Result
                                        </strong>

                                        <p>
                                            Patient: Michael Lee
                                        </p>

                                        <small>
                                            Troponin I - Critical High
                                        </small>

                                    </div>


                                </div>





                                <div className={classes.alertItem}>


                                    <div className={classes.orangeDot}></div>


                                    <div>

                                        <strong>
                                            Delayed Test
                                        </strong>

                                        <p>
                                            LAB240521-018
                                        </p>

                                        <small>
                                            Overdue by 2 hours
                                        </small>

                                    </div>


                                </div>





                                <div className={classes.alertItem}>


                                    <div className={classes.blueDot}></div>


                                    <div>

                                        <strong>
                                            Equipment
                                        </strong>

                                        <p>
                                            Analyzer Maintenance
                                        </p>

                                        <small>
                                            Scheduled at 4:00 PM
                                        </small>

                                    </div>


                                </div>


                            </div>







                            <div className={classes.todayCard}>


                                <div className={classes.cardHeader}>

                                    <h3>
                                        Today's Statistics
                                    </h3>

                                </div>




                                <div className={classes.statRow}>
                                    <span>
                                        Samples Received
                                    </span>

                                    <strong>
                                        328
                                    </strong>

                                </div>



                                <div className={classes.statRow}>
                                    <span>
                                        Samples Processed
                                    </span>

                                    <strong>
                                        182
                                    </strong>

                                </div>



                                <div className={classes.statRow}>
                                    <span>
                                        Average TAT
                                    </span>

                                    <strong>
                                        2.4 hrs
                                    </strong>

                                </div>



                                <div className={classes.statRow}>
                                    <span>
                                        Critical Results
                                    </span>

                                    <strong style={{ color: "#EF4444" }}>
                                        12
                                    </strong>

                                </div>



                                <div className={classes.statRow}>
                                    <span>
                                        Pending Tests
                                    </span>

                                    <strong style={{ color: "#F59E0B" }}>
                                        136
                                    </strong>

                                </div>



                            </div>


                        </div>





                    </div>





                    {/* BOTTOM SECTION */}


                    <div className={classes.bottomSection}>


                        <div className={classes.bottomCard}>


                            <div className={classes.cardHeader}>

                                <h3>
                                    Critical Results
                                </h3>


                                <button className={classes.viewAllBtn}>
                                    View All
                                </button>


                            </div>




                            <div className={classes.resultList}>


                                <div className={classes.resultItem}>

                                    <div>

                                        <strong>
                                            Michael Lee
                                        </strong>

                                        <p>
                                            Troponin I
                                        </p>

                                    </div>


                                    <span className={classes.criticalBadge}>
                                        Critical
                                    </span>


                                </div>




                                <div className={classes.resultItem}>

                                    <div>

                                        <strong>
                                            Sarah Adams
                                        </strong>

                                        <p>
                                            Potassium
                                        </p>

                                    </div>


                                    <span className={classes.criticalBadge}>
                                        Critical
                                    </span>


                                </div>



                                <div className={classes.resultItem}>

                                    <div>

                                        <strong>
                                            David Brown
                                        </strong>

                                        <p>
                                            Blood Culture
                                        </p>

                                    </div>


                                    <span className={classes.criticalBadge}>
                                        Critical
                                    </span>


                                </div>



                            </div>


                        </div>






                        <div className={classes.bottomCard}>


                            <div className={classes.cardHeader}>


                                <h3>
                                    Pending Tests
                                </h3>


                                <button className={classes.viewAllBtn}>
                                    View All
                                </button>


                            </div>





                            <div className={classes.resultList}>


                                <div className={classes.resultItem}>


                                    <div>

                                        <strong>
                                            LAB240521-012
                                        </strong>

                                        <p>
                                            CBC
                                        </p>


                                    </div>


                                    <span className={classes.pendingBadge}>
                                        Pending
                                    </span>


                                </div>




                                <div className={classes.resultItem}>


                                    <div>

                                        <strong>
                                            LAB240521-015
                                        </strong>

                                        <p>
                                            Liver Function Test
                                        </p>


                                    </div>


                                    <span className={classes.pendingBadge}>
                                        Pending
                                    </span>


                                </div>





                                <div className={classes.resultItem}>


                                    <div>

                                        <strong>
                                            LAB240521-018
                                        </strong>

                                        <p>
                                            Blood Sugar
                                        </p>


                                    </div>


                                    <span className={classes.pendingBadge}>
                                        Pending
                                    </span>


                                </div>


                            </div>


                        </div>







                        <div className={classes.bottomCard}>


                            <div className={classes.cardHeader}>

                                <h3>
                                    Department Summary
                                </h3>

                            </div>



                            <div className={classes.departmentRow}>
                                <span>
                                    Hematology
                                </span>
                                <strong>
                                    78
                                </strong>
                            </div>


                            <div className={classes.departmentRow}>
                                <span>
                                    Biochemistry
                                </span>
                                <strong>
                                    112
                                </strong>
                            </div>



                            <div className={classes.departmentRow}>
                                <span>
                                    Microbiology
                                </span>
                                <strong>
                                    46
                                </strong>
                            </div>



                            <div className={classes.departmentRow}>
                                <span>
                                    Serology
                                </span>
                                <strong>
                                    52
                                </strong>
                            </div>



                            <div className={classes.departmentRow}>
                                <span>
                                    Immunology
                                </span>
                                <strong>
                                    40
                                </strong>
                            </div>


                        </div>




                    </div>


                </div>

            </div>
            {selectedTest && (
                <LabResult
                    test={selectedTest}
                    onClose={() => setSelectedTest(null)}
                />
            )}
        </div>


    );


}


export default Laboratory;